import { domainCountryMap, domainLocaleMap } from "@/i18n/routing";
import {
  GLOBAL_MARKET_CODE,
  getGlobalMarketName,
  getMarketPresentation,
  type MarketMode,
} from "./market-config";

export interface ResolvedMarket {
  domain: string;
  locale: string;
  countryCode: string;
  mode: MarketMode;
  isGlobal: boolean;
  displayName: string;
  heroImage: string;
  flagCountryCode: string | null;
  apiCountryCode: string;
  searchCountryCode: string | null;
}

export function cleanDomain(domain?: string | null) {
  return (domain || "doomum.com")
    .toLowerCase()
    .split(":")[0]
    .replace(/^www\./, "");
}

export function resolveMarket({
  domain,
  locale,
}: {
  domain?: string | null;
  locale?: string | null;
}): ResolvedMarket {
  const cleanHost = cleanDomain(domain);
  const resolvedLocale = locale || domainLocaleMap[cleanHost] || "en";
  const countryCode = domainCountryMap[cleanHost] || GLOBAL_MARKET_CODE;
  const isGlobal = countryCode === GLOBAL_MARKET_CODE;

  if (isGlobal) {
    return {
      domain: cleanHost,
      locale: resolvedLocale,
      countryCode: GLOBAL_MARKET_CODE,
      mode: "global",
      isGlobal: true,
      displayName: getGlobalMarketName(resolvedLocale),
      heroImage: getMarketPresentation(GLOBAL_MARKET_CODE).heroImage,
      flagCountryCode: null,
      apiCountryCode: GLOBAL_MARKET_CODE,
      searchCountryCode: null,
    };
  }

  const presentation = getMarketPresentation(countryCode);

  return {
    domain: cleanHost,
    locale: resolvedLocale,
    countryCode,
    mode: "local",
    isGlobal: false,
    displayName: presentation.displayName,
    heroImage: presentation.heroImage,
    flagCountryCode: presentation.flagCountryCode,
    apiCountryCode: countryCode,
    searchCountryCode: countryCode,
  };
}
